import { SearchField } from "components/search/components";
import { FC } from "react";

interface Props {
  setSearch?: ({ search }: { search: string }) => void;
}

export const TableSearch: FC<Props> = ({ setSearch }) => {
  return <SearchField id={"test"} onChange={setSearch} searchType="onChange" />;
};
